import React from "react";
import { Navigate } from "react-router-dom";

function PublicRoute(props) {
  const { token } = props;
  return token ? <Navigate to={"/profile"} /> : props?.element;
}

export default PublicRoute;
